import { useSubscriptions } from '@pages/subscription/hooks';
import { DialogContent, Dialog } from '@ui/components';
import { useState, FC } from 'react';

import { DowngradeModalStep1 } from './downgrade-modal-steps/downgrade-modal-step-1';
import { DowngradeModalStep2 } from './downgrade-modal-steps/downgrade-modal-step-2';

interface DowngradeModalProps {
  subscriptionCode: string | null;
  onClose: ({ downgrade }: { downgrade: boolean }) => void;
}

export const DowngradeModal: FC<DowngradeModalProps> = ({ subscriptionCode, onClose }) => {
  const { downgradeSubscription, isDowngradeSubscriptionPending } = useSubscriptions({
    downgradeSubscriptionSuccess: () => {
      onClose({ downgrade: true });
      setStep(0);
    },
  });

  const [step, setStep] = useState<number>(0);

  const sendApplication = (questionCodes: string[]) => {
    downgradeSubscription({ subscriptionCode: subscriptionCode!, questionCodes });
  };

  return (
    <Dialog
      onOpenChange={() => {
        onClose({ downgrade: false });
        setStep(0);
      }}
      open={!!subscriptionCode}
    >
      <DialogContent>
        {step === 0 && (
          <DowngradeModalStep1
            onConfirm={() => {
              setStep(1);
            }}
            subscriptionCode={subscriptionCode}
          />
        )}
        {step === 1 && (
          <DowngradeModalStep2
            onConfirm={({ answersIds }) => {
              sendApplication(answersIds);
            }}
            isPending={isDowngradeSubscriptionPending}
          />
        )}
      </DialogContent>
    </Dialog>
  );
};
